<ng-container *ngIf="!isLoading; else loadingTemplate">
  <ng-container *ngIf="isVeaShop; else franchisePartner">
    <!--    <ng-container *ngIf="false; else franchisePartner">-->
    <ose-vea-personal-site [user]="user" [allServicesData]="allServicesData"></ose-vea-personal-site>
  </ng-container>

  <ng-template #franchisePartner>
    <ose-franchise-partner-personal-site
      [user]="user"
      [allServicesData]="allServicesData"
    ></ose-franchise-partner-personal-site>
  </ng-template>
</ng-container>

<ng-template #loadingTemplate>
  <div class="loading-wrapper">
    <app-loading></app-loading>
  </div>
</ng-template>
